export default "__VITE_ASSET__DpQDSX_J__"